// extracted by mini-css-extract-plugin
export var footerSection = "footer-module--footerSection--58f4g";